import { render, staticRenderFns } from "./health_plan_next.vue?vue&type=template&id=cafbeb54&"
import script from "./health_plan_next.vue?vue&type=script&lang=js&"
export * from "./health_plan_next.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports